"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InclusiveGatewayViewModel = void 0;
const GatewayBaseViewModel_1 = require("./GatewayBaseViewModel");
class InclusiveGatewayViewModel extends GatewayBaseViewModel_1.GatewayViewModel {
}
exports.InclusiveGatewayViewModel = InclusiveGatewayViewModel;
//# sourceMappingURL=InclusiveGatewayViewModel.js.map